/* eslint-disable no-unused-vars */
export const imgDomain = 'https://hotel-cdn.yxhotel.vip/';
